import BaseAPI from './base'

class SchoolExamAssignAPI extends BaseAPI {}

export default new SchoolExamAssignAPI('v1/school-exam-assign', 'SchoolExamAssign')
